export class ClientError {
    public readonly errorMessage: string;

    constructor(errorMessage: string) {
        this.errorMessage = errorMessage;
    }
}
